<div class="container">
    <div class="items-container">
        @for (boxesGroupInfos of datasource; track boxesGroupInfos.id) {
            <app-boxes-group [datasource]="boxesGroupInfos" [quiet]="quietChildren"></app-boxes-group>
        }
    </div>
    <div class="items-infos">
        <app-boxes-summary></app-boxes-summary>
    </div>
    <ngx-spinner name="boxes-spinner" [fullScreen]="false" type="timer" size="medium"></ngx-spinner>
</div>
